import { createStore } from "@tredespace/ui/lib";
import type { AccessKind, DeckKind, RailKind, ToolId } from "../../engine/tools/types.ts";
import type { BeamKind, BracketKind, PlankFamily } from "../../model/types.ts";

export type ToolState = Readonly<{
  tool: ToolId;
  /** Selected length in millimetres; what it means depends on the tool. */
  size: number;
  beamKind: BeamKind;
  accKind: AccessKind;
  railKind: RailKind;
  bracketKind: BracketKind;
  deckKind: DeckKind;
  plankFam: PlankFamily;
  autoSpir: boolean;
  snap: boolean;
}>;

export const toolState = createStore<ToolState>({
  tool: "nav",
  size: 3000,
  beamKind: "lb",
  accKind: "luke",
  railKind: "both",
  bracketKind: "sk",
  deckKind: "bay",
  plankFam: "mix",
  autoSpir: true,
  snap: true,
});
